export default __webpack_public_path__ + "static/Onboarding-8f5ed3cf15579efcadfd91f109218624.png";